import styled from '@mui/material/styles/styled';

const UUID = process.env.REACT_APP_UUID;
const ENV = process.env.REACT_APP_ENV;
const REGION = process.env.REACT_APP_REGION;
const IMAGE_BUCKET =
  ENV === 'dev'
    ? `solar-dev-image-bucket-${UUID}.s3.${REGION}.amazonaws.com`
    : `solar-${ENV}-image-bucket.s3.${REGION}.amazonaws.com`;

const backgroundImage = [
  'Airport-Parking.jpeg',
  'EVV4.jpeg',
  'Fort-Wayne-Airport.jpeg',
  'HamiltonCo2.jpeg',
  'Saint-Meinrad.jpeg',
  'solar-array.jpg',
][Math.floor(Math.random() * 6)];

export const Background = styled('div')({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  background: `url(https://${IMAGE_BUCKET}/${backgroundImage})`,
  backgroundSize: '100% 100%',
  backgroundRepeat: 'no-repeat',
  justifyContent: 'center',
  alignItems: 'center',
});
